import DlRcDetailsApi from "../../services/api/DlRcDetails";
import ActionTypes from "./ActionTypes";
import { setLoader, setStatus } from "./User";
import ErrorMsgs from "../../constants/Errors.json";
import SuccessMessages from "../../constants/SucessMessages.json";
import { getPath } from "../../utils";

function handleError(err) {
  console.log("error in dlrc details actions:", err);
}

export const setDlRcDetails = (payload) => {
  return {
    type: ActionTypes.SET_DLRC_DETAILS,
    payload,
  };
};

export const setEvDetails = (payload) => {
  return {
    type: ActionTypes.SET_EV_DETAILS,
    payload,
  };
};

export const setDlRcAdditionalData = (payload) => {
  return {
    type: ActionTypes.SET_DLRC_ADDITIONAL_DATA,
    payload,
  };
};

export const setCurrentFeId = (FeId) => {
  const payload = {
    feid: FeId,
  };
  return {
    type: ActionTypes.SET_DLRC_CURRENT_FEID,
    payload,
  };
};

export const resetState = (payload) => {
  return {
    type: ActionTypes.RESET_STATE_DLRC,
    payload,
  };
};

export const getDlRcDetails = (FeId) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DlRcDetailsApi.getDlRcDetails(FeId);
    console.log("response", response);
    dispatch(setLoader(false));
    if (response) {
      if (getPath(response, "ev_details", "")) {
        dispatch(setEvDetails(response.ev_details));
      } else {
        dispatch(setDlRcDetails(response));
      }
      dispatch(setCurrentFeId(FeId));
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getDlRcAdditionalData = () => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DlRcDetailsApi.getDlRcAdditionalData();
    dispatch(setLoader(false));
    if (response) {
      dispatch(setDlRcAdditionalData(response));
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const saveDlRcDetails = (FeId, payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    const response = await DlRcDetailsApi.saveDlRcDetails(FeId, payload);
    dispatch(setLoader(false));
    if (response) {
      dispatch(
        setStatus({
          type: "success",
          message: SuccessMessages.UPDATION_SUCCESS,
        })
      );
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const approveDlRcDetails = (FeId, payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    const response = await DlRcDetailsApi.approveDlRcDetails(FeId, payload);
    dispatch(setLoader(false));
    if (response) {
      dispatch(
        setStatus({
          type: "success",
          message: SuccessMessages.DLRC_APPROVED_SUCCESSFULLY,
        })
      );
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const updateDlRcField = (FeId, payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    const response = await DlRcDetailsApi.updateDlRcField(FeId, payload);
    dispatch(setLoader(false));
    if (response) {
      dispatch(
        setStatus({
          type: "success",
          message: SuccessMessages.UPDATION_SUCCESS,
        })
      );
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const updateEvQcDetails = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    const response = await DlRcDetailsApi.updateEvQcDetails(payload);
    dispatch(setLoader(false));
    if (response) {
      dispatch(
        setStatus({
          type: "success",
          message: SuccessMessages.UPDATION_SUCCESS,
        })
      );
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
